import { useEffect } from "react";
import { toast } from "sonner";
import { Skull, ArrowLeft, ShoppingCart, User } from "lucide-react";
import Shop from "@/components/Shop";
import { useCart } from "@/lib/cart";

export default function ShopPage() {
  const { count, setOpen } = useCart();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (new URLSearchParams(window.location.search).get("cancelled")) {
      window.history.replaceState({}, "", "/shop");
      setTimeout(() => toast.error("Payment cancelled — the coffin kept its loot."), 500);
    }
  }, []);

  return (
    <div data-testid="shop-page" className="min-h-screen bg-void">
      <header className="fixed top-0 inset-x-0 z-40 border-b border-blooddeep/40 bg-void/85 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="/" data-testid="shop-page-brand" className="flex items-center gap-2 group">
            <img src="/covers/atrocity-logo.webp" alt="Atrocity Comix logo" className="h-6 w-6 rounded-full transition-transform duration-200 group-hover:rotate-12" />
            <span className="font-display text-sm sm:text-base text-paper tracking-wide">
              ATROCITY <span className="text-crimson">COMIX</span>
            </span>
          </a>
          <div className="flex items-center gap-4">
            <a
              href="/"
              data-testid="shop-page-back-link"
              className="flex items-center gap-2 font-impact uppercase tracking-wider text-xs text-paper/70 transition-colors duration-150 hover:text-crimson"
            >
              <ArrowLeft size={14} /> Back to the Crypt
            </a>
            <a
              data-testid="nav-account-link"
              href="/account"
              className="p-2 text-paper transition-colors duration-150 hover:text-crimson"
              aria-label="Your account"
            >
              <User size={22} />
            </a>
            <button
              data-testid="nav-cart-trigger"
              onClick={() => setOpen(true)}
              className="relative p-2 text-paper transition-colors duration-150 hover:text-bloodglow"
              aria-label="Open cart"
            >
              <ShoppingCart size={22} />
              {count > 0 && (
                <span className="absolute -top-1 -right-1 bg-crimson text-white font-impact text-[10px] w-5 h-5 flex items-center justify-center rounded-full border border-black">
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>
      <div className="pt-16">
        <Shop />
      </div>
    </div>
  );
}
